import { useCallback, useEffect, useState } from "react";
import { UserService } from "../services/userService";
import { BiaFitUserDetailed } from "../types/user";
import { logger } from "../utils/logger";

/**
 * GET /users/show-detailed/:id — the fitness_data and weight_progress_images
 * that the plain /users/:id record (useUser) does not carry.
 *
 * `reload` refetches without toggling `loading`, so a save inside the fitness
 * modal does not flash the spinner behind it.
 */
export const useUserDetailed = (userId: number | null) => {
  const [detailedUser, setDetailedUser] = useState<BiaFitUserDetailed | null>(
    null
  );
  const [loading, setLoading] = useState(false);

  const reload = useCallback(async () => {
    if (!userId) return;
    const detailed = await UserService.getUserDetailed(userId);
    setDetailedUser(detailed);
  }, [userId]);

  useEffect(() => {
    const fetchDetailedUser = async () => {
      if (!userId) return;

      setLoading(true);
      try {
        await reload();
      } catch (err) {
        logger.error("Error fetching detailed user data:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchDetailedUser();
  }, [userId, reload]);

  return { detailedUser, loading, reload };
};
